import { render, staticRenderFns } from "./YearsReservations.vue?vue&type=template&id=178128ac&"
import script from "./YearsReservations.vue?vue&type=script&lang=js&"
export * from "./YearsReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports